import type { Auth0Plugin, User } from "@auth0/auth0-vue"
import { createAuth0 } from "@auth0/auth0-vue"
import { defineStore } from "pinia"
import { ApplicationError, ErrorCode } from "@/utils/ApplicationError"

// use auth0
const authService = createAuth0({
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  },
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  useRefreshTokens: true,
})

interface State {
  authService: Auth0Plugin
}

export const useAuthStore = defineStore("auth", {
  state: (): State => ({
    authService,
  }),
  getters: {
    user(): User | undefined {
      return this.authService.user
    },
    email(): string | undefined {
      return this.authService.user?.email
    },
    isLoading(): boolean {
      return this.authService.isLoading
    },
  },
  actions: {
    metaDataCheck() {
      if (!this.user) {
        throw new ApplicationError(ErrorCode.E9002)
      }
      if (this.user["ks::org_id"] === undefined) {
        throw new ApplicationError(ErrorCode.E9001)
      }
      if (this.user["ks::role_id"] === undefined) {
        throw new ApplicationError(ErrorCode.E9003)
      }
      if (this.user["ks::analytics_id"] === undefined) {
        throw new ApplicationError(ErrorCode.E9004)
      }
      return true
    },
  },
})
